import { render, staticRenderFns } from "./SubelementEdit.vue?vue&type=template&id=7f7199a3"
import script from "./SubelementEdit.vue?vue&type=script&lang=ts"
export * from "./SubelementEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports